import React, { useState } from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {useTranslation} from "react-i18next";

import { Button, Dropdown, Layout, Menu } from 'antd';
import { ContentText } from '../../../components/Paragraph/Paragraph';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';

import LogoGrey from '../../../assets/img/common/logo_grey.png';

const landingMenu = [
    {
        label: 'Home',
        key: 'home',
        url: '/home',
    },
    /** {
         label: 'Demo',
         key: 'demo',
        url: '/demo',
     },
     {
         label: 'Contact',
         key: 'contact',
         url: '/contact',
    },*/ 
];

const MainHeader = () => {

    const history = useHistory();
    const location = useLocation();
    const {t} = useTranslation();

    const [openMobileMenu, setOpenMobileMenu] = useState(false);

    return (
        <Layout.Header className="ubot-landing-header">
            <div className="container">
                <div className="header-content">
                    <div className="logo-wrapper">
                        <img src={LogoGrey} alt="Ubot" onClick={() => history.push('/home')} />
                    </div>
                    <div className="menu-wrapper">
                        {
                            landingMenu.map((menu, index) => {
                                return (
                                    <div className={
                                        location.pathname === menu.url ? "menu-item active me-4" : "menu-item me-4"
                                    } key={index} onClick={() => history.push(menu.url)}>
                                        {t(menu.key)}
                                    </div>
                                )
                            })
                        }
                        <Link to='/auth/register'>
                            <Button className="btn-green">{t('register')}</Button>
                        </Link>
                        <Link to='/auth/login'>
                            <Button className="btn-green ms-3" type="primary">{t('login')}</Button>
                        </Link>
                    </div>
                    <Dropdown overlay={
                        <Menu style={{width: '100px'}}>
                            {
                                landingMenu.map((menu, index) => {
                                    return (
                                        <Menu.Item key={index} onClick={() => {
                                            setOpenMobileMenu(false);
                                            history.push(menu.url);
                                        }}>
                                            <ContentText className='mb-0'>
                                                {t(menu.label)}
                                            </ContentText>
                                        </Menu.Item>
                                    )
                                })
                            }
                            <Menu.Item key='register' onClick={() => {
                                setOpenMobileMenu(false);
                                history.push('/auth/register');
                            }}>
                                <ContentText className='mb-0'>{t('register')}</ContentText>
                            </Menu.Item>
                            <Menu.Item key='login' onClick={() => {
                                setOpenMobileMenu(false);
                                history.push('/auth/login');
                            }}>
                                <ContentText className='mb-0'>{t('login')}</ContentText>
                            </Menu.Item>
                        </Menu>
                    } visible={openMobileMenu} placement="bottomRight">
                        <Button
                            shape="circle" className="no-border color-grey bg-transparent mobile-menu-button"
                            icon={openMobileMenu ? <CloseOutlined /> : <MenuOutlined />}
                            onClick={() => setOpenMobileMenu(!openMobileMenu)}
                        />
                    </Dropdown>
                </div>
            </div>
        </Layout.Header>
    )
};

export default MainHeader;